export default __webpack_public_path__ + "static/logo_open-oakland_white-2a339f5bea43e10748d80b18c36ba820.svg";